import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

export const Logo = styled(Link)`
  color: #fff;

  & span {
    color: ${({ theme }) => theme.colors.DarkYellow};
  }
`;
